import { render, staticRenderFns } from "./TopBanner.vue?vue&type=template&id=16b9b192&scoped=true&"
import script from "./TopBanner.vue?vue&type=script&lang=js&"
export * from "./TopBanner.vue?vue&type=script&lang=js&"
import style0 from "./TopBanner.vue?vue&type=style&index=0&id=16b9b192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b9b192",
  null
  
)

export default component.exports